"use client";

import { colors } from "../lib/colors";
import { cn } from "../lib/utils";

interface ScrollingTextProperties {
  text: string;
  backgroundColor?: string;
  textColor?: string;
}

// Map color values to Tailwind class names
const backgroundColorMap: Record<string, string> = {
  [colors.BOLDNESS]: "bg-boldness",
  [colors.FREEDOM]: "bg-freedom",
  [colors.STRATEGY_RED]: "bg-strategy-red",
  [colors.STRATEGY_GOLD]: "bg-strategy-gold",
  [colors.STRATEGY_GREEN]: "bg-strategy-green",
};

const textColorMap: Record<string, string> = {
  [colors.BOLDNESS]: "text-boldness",
  [colors.FREEDOM]: "text-freedom",
  [colors.STRATEGY_RED]: "text-strategy-red",
  [colors.STRATEGY_GOLD]: "text-strategy-gold",
  [colors.STRATEGY_GREEN]: "text-strategy-green",
};

const textColorOpacityMap: Record<string, string> = {
  [colors.BOLDNESS]: "text-boldness/80",
  [colors.FREEDOM]: "text-freedom/80",
  [colors.STRATEGY_RED]: "text-strategy-red/80",
  [colors.STRATEGY_GOLD]: "text-strategy-gold/80",
  [colors.STRATEGY_GREEN]: "text-strategy-green/80",
};

export function ScrollingText({
  text,
  backgroundColor = colors.BOLDNESS,
  textColor = colors.FREEDOM,
}: ScrollingTextProperties) {
  // Generate enough repetitions to ensure seamless infinite scroll
  // We need at least 2 sets to create a seamless loop (50% translation)
  const repetitions = 8;
  const textItems = Array.from({ length: repetitions }, () => text);

  const bgClass =
    backgroundColorMap[backgroundColor] || backgroundColorMap[colors.BOLDNESS];
  const textClass = textColorMap[textColor] || textColorMap[colors.FREEDOM];
  const textClassOpacity =
    textColorOpacityMap[textColor] || textColorOpacityMap[colors.FREEDOM];

  return (
    <div className={cn("relative py-12 overflow-hidden", bgClass, textClass)}>
      <div className="scrolling-text-container">
        {textItems.map((item, index) => (
          <span
            key={index}
            className={cn(
              "font-heading whitespace-nowrap mx-8 text-xl tracking-wider uppercase md:text-2xl",
              textClassOpacity,
            )}
          >
            {item}
          </span>
        ))}
      </div>
    </div>
  );
}
